/* eslint-disable quote-props */
export default {
    'ok': 'Ok',
    'Search': 'Search',
    'Address': 'Address',
    'Routing': 'Routing',
    'From here': 'From here',
    'Waypoint here': 'Waypoint here',
    'Destination here': 'Destination here',
    'Distance': 'Distance',
    'Line': 'Line',
    'Road': 'Road',
    'Area': 'Area',
    'fullScreen': 'Fullscreen',
    'gasStation': 'Gas station',
    'gasstations': 'Gas stations',
    'naturalgasstations': 'Natural gas stations',
    'electricchargers': 'Electric chargers',
    'detailedLocation': 'Detailed location',
    'street': 'Street',
    'city': 'City',
    'postalCode': 'Postal code',
    'municipality': 'Municipality',
    'regionLevel2': 'Region level 2',
    'regionLevel1': 'Region level 1',
    'country': 'Country',
    'altitude': 'Altitude',
    'maximumSpeed': 'Max speed',
    'xy': 'Y,X',
    'copy': 'Copy',
    'go': 'Go',
    'call': 'Call',
    'send:': 'Send',
    'calculateIsochrone': 'Calculate isochrone',
    'car': 'Car',
    'bicycle': 'Bicycle',
    'onFoot': 'On foot',
    'simplified': 'Simplified',
    'detailed': 'Detailed',
    'starting': 'Starting',
    'arrival': 'Arrival',
    'increments': 'Increments',
    'maxWeight': 'Max weight.',
    'maxAxleWeight': 'Max. axle weight',
    'maxHeight': 'Max. height',
    'maxLength': 'Max. length',
    'maxWidth': 'Max. width',
    'maxSpeed': 'Max. speed',
    'showRoadRestrictions': 'Show road restrictions',
    'dangerousGoods': 'Dangerous goods',
    'trc': 'Tunnel Restriction Code',
    'trucks': 'Trucks',
    'temporalRestrictions': 'Temporal restrictions',
    'startTime': 'Start time',
    'endTime': 'End time',
    'morning': 'Morning',
    'afternoon': 'Afternoon',
    'price': 'Price',
    'schedule': 'Schedule',
    'font': 'Source',
    'liveTraffic': 'Live traffic',
    'forecastTraffic': 'Forecast traffic',
    'slow': 'Slow',
    'fast': 'Fast',
    'roadWorks': 'Road works',
    'NetworkManagement': 'Network management',
    'roadClosed': 'Road closed',
    'MaintenanceWorks': 'Maintenance works',
    'roadworks': 'Roadworks',
    'AbnormalTraffic': 'Abnormal traffic',
    'queueingTraffic': 'Queueing traffic',
    'slowTraffic': 'Slow traffic',
    'stationaryTraffic': 'Stationary traffic',
    'Accident': 'Accident',
    'accident': 'Accident',
    'EnvironmentalObstruction': 'Environmental obstruction',
    'flooding': 'Flooding',
    'landslips': 'Landslips',
    'rockfalls': 'Rockfalls',
    'GeneralObstruction': 'General obstruction',
    'incident': 'Incident',
    'objectOnTheRoad': 'Object on the road',
    'obstructionOnTheRoad': 'Obstruction on the road',
    'shedLoad': 'Shed load',
    'maintenanceWork': 'Maintenance work',
    'other': 'Other',
    'resurfacingWork': 'Resurfacing work',
    'MaintenanceWorks roadworks': 'Maintenance works, roadworks',
    'MaintenanceWorks roadworks, maintenanceWork': 'Maintenance works, roadworks, maintenance work',
    'roadworks, maintenanceWork': 'Roadworks, maintenance work',
    'roadworks, maintenanceWork, resurfacingWork': 'Roadworks, maintenance work, resurfacing work',
    'roadworks, resurfacingWork': 'Roadworks, resurfacing work',
    'contraflow': 'Contraflow',
    'intermittentShortTermClosures': 'Intermittent short-term closures',
    'laneOrCarriagewayClosed': 'Lane or carriageway closed',
    'narrowLanes': 'Narrow lanes',
    'restrictions': 'Restrictions',
    'singleAlternateLineTraffic': 'Single alternate line traffic',
    'VehicleObstruction': 'Vehicle obstruction',
    'brokenDownVehicle': 'Broken down vehicle',
    'slowMovingMaintenanceVehicle': 'Slow-moving maintenance vehicle',
    'snowplough': 'Snowplough',
    'vehicleOnFire': 'Vehicle on fire',
    'obstruction': 'Obstruction',
    'monday': 'Monday',
    'tuesday': 'Tuesday',
    'wednesday': 'Wednesday',
    'thursday': 'Thursday',
    'friday': 'Friday',
    'saturday': 'Saturday',
    'sunday': 'Sunday',
    'direction': 'Direction',
    'mapCenter': 'Map center',
    'maxResults': 'Max. results',
    'maxRadius': 'Max. radius',
    'viewOnMap': 'View on map',
    'proximity': 'Proximity',
    'selectCategories': 'Select categories',
    'minimizeRoutingMenu': 'Minimize routing menu',
    'closeRouteMenu': 'Close route menu',
    'writeOrClickMap': 'Write or click on the map',
    'routeTo': 'To...',
    'waypoint': 'Waypoint ...',
    'addWaypoint': 'Add waypoint',
    'cleanRoute': 'Clean route',
    'saveRoute': 'Save route',
    'printRoute': 'Print route',
    'modifyRouteOptions': 'Modify route options',
    'logisticsRoute': 'Truck route',
    'routeType': 'Route type',
    'time': 'Time',
    'restTime': 'Rest time',
    'distance': 'Distance',
    'avoidTolls': 'Avoid tolls',
    'realtime': 'Real time',
    'optimizedRoute': 'Optimized route',
    'addedCosts': 'Added costs',
    'departureTime': 'Departure time',
    'moreDetails': 'More details',
    'routeCar': 'Route by car',
    'routeTruck': 'Route by truck',
    'withoutTraffic': 'without traffic',
    'ofRest': 'of rest (tachograph)',
    'ZBEInfo': 'Information about this low emission zone',
    'hour': 'Hour',
    'roadRestrictions': 'Road restrictions',
    'addBreakTime': 'Add break time (tachograph)',
    'twoDrivers': 'Two drivers',
    'refresh': 'Refresh',
    'disabled': 'Disabled',
    'sunLight': 'Sun lightning',
    'neighborhoods': 'Neighborhoods',
    'postalcodes': 'Postal Codes',
    'municipalities': 'Municipalities',
    'routeStopsFrom': 'From:',
    'routeStopsThrought': 'through:',
    'routeStopsTo': 'to:',
    'routeStopsTrafficDelay': 'traffic delay',
    'routeSummaryDetails': 'DETAILS',
    'routeSummaryTraficJam': 'traffic jam',
    'searchAddress': 'Address',
    'searchPostalCode': 'Postal code',
    'searchCoordinates': 'Coordinates',
    'searchLocality': 'Locality',
    'searchPOIs': 'POIs',
    'searchSearchBtn': 'Search',
    'searchNearestAddress': 'Nearest address',
    'searchSelectCountry': 'Select country',
    'searchAllCountries': 'All countries',
    'searchProjection': 'Projection',
    'searchXCoordinate': 'X coordinate',
    'searchYCoordinate': 'Y coordinate',
    'searchCandidates': 'Candidates',
    'tooltipAdvancedSearch': 'Advanced search',
    'tooltipRouting': 'Calculate route',
    'tooltipPois': 'Points of interest',
    'tooltipMeteo': 'Weather forecast',
    'tooltipGasStations': 'Gas stations',
    'tooltipTraffic': 'Traffic',
    'tooltipZBE': 'Low emission zones',
    'tooltipStreetView': 'Street view',
    'tooltipClean': 'Clean map',
    'tooltipDraw': 'Draw',
    'tooltipLayerSwitcher': 'Change map',
    'tooltipFullScreen': 'Fullscreen',
    'tooltipLayerRegion': 'Add administrative layer',
    'tooltipLogisticsRestrictions': 'Truck road restrictions',
    'tooltipIsochrones': 'Calculate isochrones',
    'tooltipBuildings3D': 'See buildings in 3d view',
    'rainRadar': 'Rain radar',
    'notificationRouteCantGetPosition': 'Cannot get your current position. Please fill origin direction input.',
    'notificationErrorSavingKML': 'Error saving KML.',
    'notificationErrorGetPostalCode': 'Cannot get postal code. Error: ',
    'notificationControlAlreadyExists': 'Control already exists:',
    'notificationSelectCategories': 'First select the categories',
    'notificationPoisNotFound': 'POIs not found',
    'notificationDrawIsochrone': 'Click on the point of the map that you want to calculate the isochrone',
    'notificationErrorGetPathRouting': 'Could not find the path of the route, check the step points',
    'assertMapNotDefined': 'Map not defined',
    'assertFeatureExists': 'Feature already exists',
    'assertUnknownBaseLayer': 'Unknown setBaseLayer: ',
    'assertLayerNotSpecified': 'Layer not specified',
    'asserInvalidObjectLonLat': 'Not a \'cercalia.LonLat\' type object',
    'assertUknownWeight': 'Uknown weight: ',
    'assertParameterIsNotFunction': 'Parameter is not a callback function',
    'assertUknownParameter': 'Uknown parameter: ',
    'assertOriginInvalid': 'Can\'t calculate route. Invalid origin: ',
    'assertStepInvalid': 'Can\'t calculate route. Invalid step: ',
    'assertDestinationInvalid': 'Can\'t calculate route. Invalid destination: ',
    'assertProjectionNotDefined': 'Layer projection not declared: ',
    'assertGpsNotPosition': 'Can\'t get GPS position.',
};
//# sourceMappingURL=en.js.map